import React, {useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import { properties } from '../properties';
import $ from "jquery";

function SoapResponse(props) {
    let msg = props.message.split("SOAP-ENV:").join("");
    let parser1 = require("fast-xml-parser");
    var options = {
        parseTrueNumberOnly: true,
    };
    var jsonObj = parser1.parse(msg, options);
    var responseBody = useState([]);
    try{
        var wpg_operation = props.operation;
        var fieldName;
        for (var outfield in properties.output_params_soap[wpg_operation]) {
            fieldName=properties.output_params_soap[wpg_operation][outfield];
            if(fieldName===properties.RESPONSE_APP_ID_FIELDNAME){
                fieldName=properties.NEW_RESPONSE_APP_ID_FIELDNAME;
            }
            responseBody.push(
                <div className="form-group" key={outfield}>
                    <div className="control-label ">
                        {fieldName}
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {jsonObj.Envelope.Body[Object.keys(jsonObj.Envelope.Body)[0]][properties.output_params_soap[wpg_operation][outfield]]} </div>
                    </div>
                </div>
            );
        }
    }
    catch(error){
        responseBody.push(
            <div className="form-group">
                <div className="control-label ">
                    Parse Error
                </div>
                <div className="col-sm-5">
                    <div className="response-form-control">{JSON.stringify(jsonObj)}</div>
                </div>
            </div>
        );
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);
    
    return (
        <div className="operation-response">
            <h2>{props.title}</h2>
            {responseBody}
            <div className = "form-group">
                <div className="col-sm-5">
                    <Link to="/soapui">
                        <button type="submit" className="btn btn-primary">Back</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default SoapResponse;